import Vue from 'vue';
import VueRouter from 'vue-router';
// import axios from 'axios';
import Landing from '../views/Landing.vue';
import ChooseLocation from '../views/ChooseLocation.vue';
import SetupTest from '../views/SetupTest.vue';
import DeviceTest from '../views/DeviceTest.vue';
import Troubleshoot from '../views/TroubleshootPage.vue';
import CompleteRegistration from '../views/CompleteRegistration.vue';
import DownloadMobileApp from '../views/DownloadMobileApp.vue';
import ErrorPage from '../views/ErrorPage.vue';
import { setCookie, getCookie } from '../utility/cookie';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Landing,
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Landing,
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Landing,
  },
  {
    path: '/location',
    name: 'Location',
    component: ChooseLocation,
  },
  {
    path: '/setup-test',
    name: 'SetupTest',
    component: SetupTest,
  },
  {
    path: '/test',
    name: 'DeviceTest',
    component: DeviceTest,
  },
  {
    path: '/troubleshoot',
    name: 'Troubleshoot',
    component: Troubleshoot,
  },
  {
    path: '/register',
    name: 'CompleteRegistration',
    component: CompleteRegistration,
  },
  {
    path: '/mobile-app',
    name: 'DownloadMobileApp',
    component: DownloadMobileApp,
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/* const checkMaintenance = async () => {
  const results = await axios.get(process.env.VUE_APP_PULSE_API_BASE_URL);
  if (!results.data.message || typeof results.data.message !== 'undefined') return true;
  return false;
}; */

router.beforeEach((to, from, next) => {
  if (to.name !== 'Welcome' && !getCookie('has_visited')) {
    next('welcome');
    setCookie('has_visited', true, 720);
  } else if (to.name === 'Welcome' && getCookie('has_visited')) {
    next('');
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  const sessionToken = getCookie('cellbridge_session_token');
  if (!sessionToken && to.name !== 'Login' && to.name !== 'Register' && to.name !== 'Welcome') {
    next('/');
  } else if (
    sessionToken !== false && (to.name === 'Login' || to.name === 'Register' || to.name === 'Welcome')
  ) {
    next(false);
  } else {
    next();
  }
});

/* router.beforeEach(async (to, from, next) => {
  const allowedToLogin = await checkMaintenance();
  if (!allowedToLogin) next({ name: 'Maintenance' });
  next();
}); */
export default router;
